export default function getNetlifyTrustToken() {
    return process.env.NETLIFY_TRUSTED_TOKEN;
}
//# sourceMappingURL=getNetlifyTrustToken.js.map